import React from "react";

const InputWithIcon = ({
  id,
  title = "",
  wrapperClassName = "",
  leftIcon,
  leftIconClassName = "",
  type = "text",
  placeholder = "",
  containerClassName = "",
  inputClassName = "",
  rightIcon,
  rightIconClassName = "",
  rightIconHandler,
  rightIconStyle,
  labelClassName = "",
  required = false,
  disabled = false,
  value,
  onChange,
  error = "",
  autoComplete,
  min = "0",
  name,
  fullEventData = false,
  submitEvent = () => {}
}) => {
  return (
    <div className={`${wrapperClassName}`}>
      {title ? (
        <label
          htmlFor={id}
          className={`font-size-small text-[var(--blackColor)] ${labelClassName}`}
        >
          {title}
          {required ? <span className="text-[#e55353]"> *</span> : null}
        </label>
      ) : null}

      <div className={`input-container mt-2 ${containerClassName}`}>
        {leftIcon ? (
          <img
            src={leftIcon}
            className={`input-icon ${leftIconClassName}`}
            alt="input icon left"
          />
        ) : null}
        <input
          type={type}
          placeholder={placeholder}
          className={`input-field font-size-medium ${inputClassName}`}
          disabled={disabled}
          value={value}
          onChange={(e) => {
            fullEventData ? onChange(e) : onChange(e.target.value);
          }}
          autoComplete={autoComplete}
          min={min}
          name={name}
          onKeyDown={submitEvent}
        />
        {rightIcon ? (
          <img
            src={rightIcon}
            className={`input-icon-right ${rightIconClassName}`}
            alt="input icon right"
            onClick={rightIconHandler}
            style={rightIconStyle}
          />
        ) : null}
      </div>
      {error ? (
        <div className={`font-size-small text-[var(--textRed)] mt-2`}>
          {error}
        </div>
      ) : null}
    </div>
  );
};

export default InputWithIcon;
